import { Dispatch } from "redux";
import { setAxnAdminSessionsLoading, setAxnAdminSessions } from "@redux/actions/axn-admin-sessions-actions";
import { FormattedAxnAdminSession } from "@idw-types/data/management-console/axnadmin";
import { getActiveAxnAdminSessionsRequest } from "@requests/management-console/get-active-axn-admin-sessions";
import { formatAxnAdminSessions } from "@formatters/management-console/axnadmin/axn-admin-session-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getAxnAdminSessionsReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<FormattedAxnAdminSession>> => {
    dispatch(setAxnAdminSessionsLoading(true));
    const { data, error } = await getActiveAxnAdminSessionsRequest();
    if (data?.sessions) {
        const formattedAxnAdminSessions = formatAxnAdminSessions(data.sessions);
        dispatch(setAxnAdminSessions(formattedAxnAdminSessions));
        return formattedAxnAdminSessions;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAxnAdminSessions.error.title,
                resources.requests.getAxnAdminSessions.error.message
            );
        }
        dispatch(setAxnAdminSessionsLoading(false));
        return null;
    }
};